export const hawaii = {
  "15000": "Hawaii",
  "15001": "Hawaii County",
  "15003": "Honolulu County",
  "15005": "Kalawao County",
  "15007": "Kauai County",
  "15009": "Maui County",
};
